import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { I18NextPipe, I18NextService } from 'angular-i18next';
import { TableCellDirective, TableGridComponent } from 'mbs-ui-kit';
import { AwsDetail } from 'mbs-ui-shared@components/components/models/license.model';
import { getTableHeaders } from 'mbs-ui-shared@components/licenses/components/aws-table/constants/table';
import { LicensesPipesModule } from 'mbs-ui-shared@components/licenses/pipes/licenses-pipes.module';

@Component({
  selector: 'mbs-aws-table',
  templateUrl: './aws-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, LicensesPipesModule, I18NextPipe, TableGridComponent, TableCellDirective]
})
export class AwsTableComponent {
  private i18n = inject(I18NextService);

  public tableMaxHeight = input<string>('50vh');

  public licenses = input<Array<AwsDetail>>();
  public total = input<number>(null);
  public loading = input<boolean>(false);

  protected headers = getTableHeaders(this.i18n);
}
